export const triggerMessageRequestOptions21 = [
  'BootNotification',
  'LogStatusNotification',
  'FirmwareStatusNotification',
  'Heartbeat',
  'MeterValues',
  'SignChargingStationCertificate',
  'SignV2GCertificate',
  'StatusNotification',
  'TransactionEvent',
  'SignCombinedCertificate',
  'PublishFirmwareStatusNotification',
] as const;

export type TriggerMessageRequestOption21 =
  (typeof triggerMessageRequestOptions21)[number];
